export const getAnswer = (options: any[], interaction: Record<string, any>) => {
  if (interaction.interactionType === 'poll') {
    return null;
  }
  return options.find(option => option.correct).id;
};
